export const ADD_ROLE_REQUEST = "ADD_ROLE_REQUEST";
export const ADD_ROLE_SUCCESS = "ADD_ROLE_SUCCESS";
export const ADD_ROLE_FAILURE = "ADD_ROLE_FAILURE";
export const RESET_ROLE_STATE = "RESET_ROLE_STATE";
export const FETCH_ROLES_REQUEST = "FETCH_ROLES_REQUEST";
export const FETCH_ROLES_SUCCESS = "FETCH_ROLES_SUCCESS";
export const FETCH_ROLES_FAILURE = "FETCH_ROLES_FAILURE";
export const ADD_ROLE = "ADD_ROLE";
export const EDIT_ROLE = "EDIT_ROLE";
export const DELETE_ROLE = "DELETE_ROLE";
export const SEARCH_ROLES = "SEARCH_ROLES";
export const FETCH_ROLE_BY_ID_REQUEST = "FETCH_ROLE_BY_ID_REQUEST";
export const FETCH_ROLE_BY_ID_SUCCESS = "FETCH_ROLE_BY_ID_SUCCESS";
export const FETCH_ROLE_BY_ID_FAILURE = "FETCH_ROLE_BY_ID_FAILURE";
export const UPDATE_ROLE_REQUEST = "UPDATE_ROLE_REQUEST";
export const UPDATE_ROLE_SUCCESS = "UPDATE_ROLE_SUCCESS";
export const UPDATE_ROLE_FAILURE = "UPDATE_ROLE_FAILURE";
export const DELETE_ROLE_REQUEST = "DELETE_ROLE_REQUEST";
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";
export const DELETE_ROLE_FAILURE = "DELETE_ROLE_FAILURE";
export const FETCH_ROLE_DETAILS_REQUEST = "FETCH_ROLE_DETAILS_REQUEST";
export const FETCH_ROLE_DETAILS_SUCCESS = "FETCH_ROLE_DETAILS_SUCCESS";
export const FETCH_ROLE_DETAILS_FAILURE = "FETCH_ROLE_DETAILS_FAILURE";
